import i18next from "i18next";

export interface ContextualTip {
  id: string;
  element: string;
  title: string;
  description: string;
  side: "top" | "bottom" | "left" | "right" | "over";
  align: "start" | "center" | "end";
  autoDismissMs: number;
}

interface ContextualTipDef {
  id: string;
  element: string;
  titleKey: string;
  descKey: string;
  side: "top" | "bottom" | "left" | "right" | "over";
  align: "start" | "center" | "end";
  autoDismissMs: number;
}

const CONTEXTUAL_DEFS: Record<string, ContextualTipDef> = {
  "ctx-3d-mode": {
    id: "ctx-3d-mode",
    element: "#designer-canvas",
    titleKey: "tips.contextual.threeDModeTitle",
    descKey: "tips.contextual.threeDModeDesc",
    side: "over",
    align: "center",
    autoDismissMs: 5000,
  },
  "ctx-drawer-active": {
    id: "ctx-drawer-active",
    element: "#designer-canvas",
    titleKey: "tips.contextual.drawerActiveTitle",
    descKey: "tips.contextual.drawerActiveDesc",
    side: "top",
    align: "center",
    autoDismissMs: 5000,
  },
  "ctx-product-selected": {
    id: "ctx-product-selected",
    element: ".float-menu",
    titleKey: "tips.contextual.productSelectedTitle",
    descKey: "tips.contextual.productSelectedDesc",
    side: "bottom",
    align: "center",
    autoDismissMs: 5000,
  },
  "ctx-corner-buttons": {
    id: "ctx-corner-buttons",
    element: ".corner-button",
    titleKey: "tips.contextual.cornerButtonsTitle",
    descKey: "tips.contextual.cornerButtonsDesc",
    side: "top",
    align: "center",
    autoDismissMs: 5000,
  },
  "ctx-back-to-2d": {
    id: "ctx-back-to-2d",
    element: "#view-mode-toggle",
    titleKey: "tips.contextual.backTo2dTitle",
    descKey: "tips.contextual.backTo2dDesc",
    side: "bottom",
    align: "center",
    autoDismissMs: 4000,
  },
};

export function getContextualTip(tipId: string): ContextualTip | undefined {
  const def = CONTEXTUAL_DEFS[tipId];
  if (!def) return undefined;
  return {
    id: def.id,
    element: def.element,
    title: i18next.t(def.titleKey),
    description: i18next.t(def.descKey),
    side: def.side,
    align: def.align,
    autoDismissMs: def.autoDismissMs,
  };
}

export const contextualTipIds = Object.keys(CONTEXTUAL_DEFS);
